import React, { FC } from 'react';
import { EligibilityInfo } from './EligibilityInfo';
import { DeprecatedButtonGroup } from '@modernhealth/vital-components';
import { ScreenContainer } from 'src/modules/dependents/components/ScreenContainer';
import { useTranslation } from 'react-i18next';

interface EligibleToJoinProps {
    onReturnHome: (buttonCopy: string) => void;
    onInviteDependent: VoidFunction;
}

export const EligibleToJoin: FC<EligibleToJoinProps> = ({ onReturnHome, onInviteDependent }) => {
    const { t } = useTranslation();
    return (
        <ScreenContainer>
            <EligibilityInfo status="join" />
            <DeprecatedButtonGroup
                firstButtonText={t('dependents:common.not_now')}
                onFirstButtonClick={() => onReturnHome(t('dependents:common.not_now'))}
                secondButtonText={t('dependents:common.invite_dependent')}
                onSecondButtonClick={onInviteDependent}
                marginTop={42}
            />
        </ScreenContainer>
    );
};
